import { render } from "./AiVersionSelector.vue?vue&type=template&id=265bfeba"
import script from "./AiVersionSelector.vue?vue&type=script&lang=js"
export * from "./AiVersionSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__